import { useQuery } from "@tanstack/react-query"
import { useTRPC } from "utils/trpc"

const useProjects = ({
  includeMetrics = false,
}: { includeMetrics?: boolean } = {}) => {
  const trpc = useTRPC()
  return useQuery(
    trpc.projects.getProjects.queryOptions({ include_metrics: includeMetrics })
  )
}

export default useProjects
